<template>
  <div>
    <Side></Side>
    <FullMenu></FullMenu>
    <Nav></Nav>
    <div id="home" class="current-page" data-page="home">
      <div id="hero" style="background-image: url(assets/images/home-hero-bg.jpg)">
        <div class="caption">
          <h2>Your Brand here</h2>
          <p>Matérias-primas e produtos são analisados e ensaiados laboratorialmente.
            <br>Usamos as melhores soluções técnicas e elevados padrões de qualidade e segurança.
          </p>
          <a href="#" class="more-button white lg">+</a>
        </div>
        <a class="arrow-bottom">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18.468"
            height="146.9"
            viewBox="0 0 18.468 146.9"
          >
            <g transform="translate(0.707 145.486) rotate(-90)">
              <path
                d="M8.527,17.054,0,8.527,8.527,0"
                transform="translate(0)"
                fill="none"
                stroke="#ccc"
                stroke-width="2"
              ></path>
              <path
                d="M0,0H145.486"
                transform="translate(0 8.526)"
                fill="none"
                stroke="#ccc"
                stroke-width="2"
              ></path>
            </g>
          </svg>
        </a>
      </div>
      <div id="about-us" class="section-r-content">
        <div class="container-sm">
          <div class="content">
            <div class="title">
              <h3>SOBRE NÓS</h3>
            </div>
            <div class="subtitle">
              <h2>Fundada em 1968</h2>
            </div>
            <div class="row text">
              <div class="col-md-6">
                A Manulena nasceu vocacionada para a produção de velas de culto e velas para iluminação, onde a qualidade dos produtos foi determinante no sucesso da empresa. A sua boa aceitação constituiu um forte incentivo que levou ao
                desenvolvimento de tecnologias próprias e a
              </div>
              <div class="col-md-6">
                criação de novas gamas nas áreas da decoração e do ambiente. Matérias-primas e produtos são analisados e
                ensaiados laboratorialmente, assegurando assim as melhores soluções técnicas e elevados padrões de qualidade e segurança.
              </div>
            </div>
            <div class="read-more">
              <a href="quem-somos" class="more-button">+</a>
            </div>
          </div>
        </div>
      </div>
      <div id="know-how">
        <div class="sliders">
          <div class="slider-left">
            <div class="owl-carousel owl-theme">
              <div class="item">
                <img src="assets/images/slider-1.jpg" alt="slider-1">
              </div>
              <div class="item">
                <img src="assets/images/slider-2.jpg" alt="slider-2">
              </div>
            </div>
          </div>
          <div class="slider-right">
            <div class="owl-carousel owl-theme">
              <div class="item">
                <img src="assets/images/slider-1.jpg" alt="slider-1">
              </div>
              <div class="item">
                <img src="assets/images/slider-2.jpg" alt="slider-2">
              </div>
            </div>
            <div class="next-button">
              <a class="slider-next">
                <img src="assets/svg/next.svg" alt="next">
              </a>
            </div>
          </div>
        </div>
        <div class="slider-content">
          <div class="title">Know how</div>
          <div class="text">
            A Manulena é um produtor de velas, difusores e cosmética que opera no mercado há mais de 50 anos.
            80% da sua produção é orientada para marcas de Luxo e de Mass Market.
            <br>Conheça toda a gama de produtos.
          </div>
          <a class="more-button" href="o-que-fazemos">+</a>
        </div>
      </div>
      <div id="what-we-do" class="section-r-content dark">
        <div class="container-sm">
          <div class="content">
            <div class="title">
              <h3>O QUE FAZEMOS</h3>
            </div>
            <div class="subtitle">
              <h2>Tecnologia, inovação, qualidade</h2>
            </div>
            <div
              class="text"
            >Conhecemos o processo de A a Z. combinando qualidade, inovação e tecnologia. Possuímos uma gama imensa de produtos, reflexo da constante evolução dos mercados e da longevidade da marca.</div>
          </div>
        </div>
        <div class="container-lg">
          <div class="row">
            <div class="col-md-6">
              <div class="image-caption">
                <img src="assets/images/what1.jpg" alt="what1">
                <a href="exclusive-brands" class="more-button light">+</a>
              </div>
              <h4 class="what-title">Exclusive Brands</h4>
            </div>
            <div class="col-md-6">
              <div class="image-caption">
                <img src="assets/images/what2.jpg" alt="what1">
                <a href="private-label" class="more-button light">+</a>
              </div>
              <h4 class="what-title">Private Label</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="section-r-content produtos-list">
        <div class="container-sm">
          <div class="content">
            <div class="title">
              <h3>PRODUTOS</h3>
            </div>
            <div class="subtitle">
              <h2>Em destaque</h2>
            </div>
          </div>
        </div>
        <div class="container-md">
          <div class="row">
            <div
              class="col-md-3 produto"
              :key="'produto-' + produto.id"
              v-for="produto in produtos.take(4)"
            >
              <img :src="produto.images[0].url" alt="produto-1">
              <h4 class="produto-name">{{ produto.title }}</h4>
              <a class="more-button" :href="produto.url">+</a>
            </div>
          </div>
        </div>
      </div>
      <div id="video">
        <div class="container-md">
          <div class="image-caption">
            <img src="assets/images/video.jpg" alt>
            <div class="play-button">
              <img src="assets/svg/play.svg" alt>
            </div>
          </div>
        </div>
      </div>
      <div id="cta" style="background-image: url(assets/images/cta-bg.jpg)">
        <div class="container-sm">
          <div class="content">
            <h4>
              Entre em
              <span class="x">contacto</span> connosco
            </h4>
            <p>Se procura soluções à medida, temos à disposição os meios e a experiência para satisfazer qualquer pedido</p>
            <a href="#" class="button x">CONTACTO</a>
          </div>
        </div>
      </div>
      <div id="newsletter">
        <div class="container-lg">
          <form>
            <input type="text" placeholder="INSIRA O SEU EMAIL E SUBSCREVA A NOSSA NEWSLETTER">
            <button class="unstyled-button">SUBSCREVER</button>
          </form>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Side from "../partials/side";
import Footer from "../partials/footer";
import FullMenu from "../partials/full-menu";
import Nav from "../partials/nav";

import Produtos from "../Controllers/Produtos";

export default {
  components: {
    Side,
    Footer,
    FullMenu,
    Nav
  },
  data() {
    return {
      produtos: new Produtos()
    };
  }
};
</script>

<style>
</style>
